import { BaseReceiptStatusDto } from '@api';

const baseDeliveryNoteReplyStatus: BaseReceiptStatusDto = {
  id: 0,
  status: '',
  created: '2021-01-01Z00:00:000Z',
  lastChange: '2021-01-01Z00:00:000Z',
};

export const DELIVERY_NOTE_REPLY_STATUS: BaseReceiptStatusDto[] = [
  {
    ...baseDeliveryNoteReplyStatus,
    id: 1,
    status: 'Status A',
  },
  {
    ...baseDeliveryNoteReplyStatus,
    id: 2,
    status: 'Status B',
  },
  {
    ...baseDeliveryNoteReplyStatus,
    id: 3,
    status: 'Status C',
  },
  {
    ...baseDeliveryNoteReplyStatus,
    id: 4,
    status: 'Status D',
  },
];
